











































































































































































































































import Vue from 'vue';
import AgregarRecibo from '@/components/recibos/AgregarRecibo.vue';
import Aclaracion from '@/components/recibos/Aclaracion.vue';
import AgregarNotaCredito from '@/components/recibos/AgregarNotaCredito.vue';
// import AgregarReciboCopy from '@/components/recibos/AgregarReciboCopy.vue';
import ReciboFormato from '@/components/recibos/ReciboFormato.vue';
import EnviarRecibo from '@/components/recibos/EnviarRecibo.vue';
import ReciboBatch from '@/components/recibos/ReciboBatch.vue';
import LoteRecibos from '@/components/recibos/LoteRecibos.vue';
import EnviarRecordatorios from '@/components/recibos/RecordatoriosMultiples.vue';
import Cobro from '@/components/recibos/Cobro.vue';
import CobroItem from '@/components/recibos/CobroItem.vue';
import firstCharsToUpperCase from '../util/firstCharsToUpperCase';

export default Vue.extend({
  components: { AgregarRecibo, AgregarNotaCredito,
  // AgregarReciboCopy,
  Aclaracion, ReciboFormato, EnviarRecibo, ReciboBatch, LoteRecibos, Cobro, CobroItem, EnviarRecordatorios },
  data: () => ({
    singleSelect: false,
    selected: [],
    ids: [],
    headers1: [
      { text: 'Concepto', value: 'concepto.nombre', sortable: false, width: 150},
      { text: 'Cantidad', value: 'cantidad', sortable: false, width: 150},
      { text: 'Precio/Unidad', value: 'unitario', sortable: false, width: 150},
      { text: 'Importe', value: 'importe', sortable: false, width: 150},
    ],
    headers: [
      { text: 'Unidad', value: 'unidad.name', sortable: false, width: 150},
      { text: 'Periodo', value: 'periodo', sortable: false, width: 140},
      { text: 'Propietario', value: 'propietario.nombre', sortable: false, width: 150 },
      { text: 'tipo', value: 'tipoDeComprobante', width: 50 },
      { text: 'Serie', value: 'serie', width: 80},
      { text: 'Folio', value: 'folio', width: 85},
      { text: 'Subtotal', value: 'subtotal', width: 120 },
      { text: 'Total', value: 'total', width: 120 },
      { text: 'Status', value: 'pagoStatus', width: 50},
      { text: 'ADEUDO', value: 'openTotal', width: 120},
    ],
    delay: 300,
    clicks: 0,
    timer: null,
    botonActivo: true,
    detailInfo: {},
    total: 0,
    Recibos: [],
    loading: true,
    options: { page: 1, itemsPerPage: 100 },
    options2: { page: 1, itemsPerPage: 20 , sortBy: ''},
    dialog: false,
    dialogCR: false,
    isSelectedEmpty: true,
    isSelectedUnique: false,
    precision: 2,
    itemUnidad: [],
    itemPeriodo: [],
    itemPropietario: [],
    filters: {
      propietario: '',
      periodo: '',
      unidad: '',
      idPropietario: null,
      idUnidad: null,
    },
    datos: {
      unidad: {},
      propietario: {},
    },
    menuPeriodo: false,
    date: '',
    indexSelected: -1,
  }),
  mounted() {/* vacio */},
  methods: {
    loadData() {
      this.indexSelected++;
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const options = this.options2;
      const datos = {admin, condo};
      const unidades = (this.itemUnidad.length === 0) ? (
              this.$store.dispatch('getUnidadesListMax', {datos, options})
              .then((result) => this.itemUnidad = result.content)
              .catch((e) => this.$toast.error(e))) : this.itemUnidad;
      const propietarios = (this.itemPropietario.length === 0) ? (
              this.$store.dispatch('getPropietCondoListMax', {admin, condo, options})
              .then((result) => this.itemPropietario = result.content)
              .catch ((e) => this.$toast.error(e))) : this.itemPropietario;
      const recibos = this.filter();
      Promise.all([unidades, propietarios, recibos])
        .then((values) => this.loading = false);
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.selected = [];
      this.loadData();
    },
    // verRecibo(item) {
    //   this.setRecibo(item);
    // },
    showInfo(event) {
      const recibo = event;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      this.$store.dispatch('getReciboById', {condo, admin, recibo})
        .then((response) => {
          console.log('getReciboById response: %o', response);
          this.detailInfo = response;
          this.dialog = true;
        })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
    },
    closeDialog() {
      this.dialog = false;
      this.botonActivo = true;
      this.detailInfo = {};
    },
    rowSelected(event) {
      this.clicks++;
      if (this.clicks === 1) {
        const self = this;
        this.timer = setTimeout(() => {
          self.clicks = 0;
        }, this.delay);
        const boolAndIndex = this.isReciboInArray(event, this.selected);
        const isInSelected = boolAndIndex.boolValue;
        const index = boolAndIndex.index;
        if (isInSelected) {
          this.selected.splice(index, 1);
        } else {
          this.selected.push(event);
        }
      } else {
        clearTimeout(this.timer);
        this.showInfo(event);
        this.clicks = 0;
      }
    },
    goToBorradores() {
      this.$router.push({name: 'loteRecibos'});
    },
    isReciboInArray(recibo, recibosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const rec of recibosArray) {
        if (rec.id === recibo.id) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
    periodo(item) {
      const fecha = this.$moment(item.periodo).format('MMMM YYYY');
      return firstCharsToUpperCase(fecha);
    },
    filter() {
      (this.indexSelected === -1) ? (this.selected = [], this.options.page = 1) : this.indexSelected = -1;
      this.asigFilters();
      this.total = 0;
      this.Recibos = [];
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const filters = this.filters;
      const options = this.options;
      // console.debug('OPTIONS %o', options);
      const datos = {admin, condo, options, filters};
      // console.debug('getRecibosList DATOS:%o', datos);
      const recibos = this.$store.dispatch('findUnidades', datos)
        .then((result) => { console.debug('getRecibosList RESPONSE: %o', result.content);
                            this.Recibos = result.content;
                            this.total = result.totalElements; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
      this.menuPeriodo = false;
      return recibos;
    },
    asigFilters() {
      const filtro = this.datos.unidad;
      const filtroP = this.datos.propietario;
      // console.log('FECHA: ', this.date);
      (filtro != null) ? (this.filters.unidad = filtro.name,
                          this.filters.idUnidad = filtro.id)
                       : (this.filters.unidad = '',
                          this.filters.idUnidad = '');
      (filtroP != null) ? (this.filters.propietario = filtroP.nombre,
                           this.filters.idPropietario = filtroP.id)
                        : (this.filters.propietario = '',
                           this.filters.idPropietario = '');
      (this.date !== '') ? this.filters.periodo = this.$moment(this.date).format('YYYY-MM')
                         : this.filters.periodo = '';
    },
    cleanDate() {
      this.date = '';
      this.menuPeriodo = false;
      this.filter();
    },
    getFormat(periodo) {
      return this.$moment(periodo).format('MMMM-YYYY').toUpperCase();
    },
    printData() {
      this.$htmlToPaper('reciboImprimir');
    },
    async sendData() {
      this.botonActivo = false;
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const recibo = this.detailInfo.id;
        this.loading = true;
        const result = await this.$store.dispatch('sendAviso', {admin, condo, recibo});
        this.$toast.success('Detalle Enviado');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
    },
    async updateStatusRecibo() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const recId = this.selected[0].id;
        // console.log('update: ', admin.id, condo.id, recId);
        // console.log('recibo ', this.selected[0].pagoStatus);
        const result = await this.$store.dispatch('updateStatusRecibo', {admin, condo, recId});
        console.log('resultUpdate: ', result);
        this.$toast.success('recibo ' + this.selected[0].folio + ' cancelado');
        this.loadData();
        this.selected.splice(0, this.selected.length);
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      this.dialogCR = false;
    },
  },
  computed: {
    computedDateFormatted() {
      if (this.date !== '') {
        const fecha = {periodo: '' };
        fecha.periodo = this.$moment(this.date).format();
        return this.periodo(fecha);
      } else {
        this.date = '';
        return this.date;
      }
    },
  },
  watch: {
    openDialog() {
      if (this.dialog) {
        this.botonActivo = true;
      }
    },
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.ids = [];
        this.isSelectedEmpty = true;
        this.isSelectedUnique = false;
      } else {
        if (this.selected.length === 1) {
          this.isSelectedUnique = true;
        } else {
          this.isSelectedUnique = false;
        }
        let i = 0;
        this.ids = [];
        for (i = 0; i < this.selected.length; i++) {
          this.ids.push(this.selected[i].id);
        }
        // console.log('IDS: %o', this.ids);
        this.isSelectedEmpty = false;
      }
    },
  },
});
